module.exports = __webpack_public_path__ + "img/huodonbggue.74ac3e5f.png";